import * as React from "react";
import {
  connectionErrorAdvice,
  normalizeConnectionError,
} from "../../Troubleshooting/TroubleshootingUtils/connectionErrorAdvice";

/**
 * One red line under "Connected" when the connector's last VMS login failed
 * (`last_connection_error` on camera/{id}/status/, ENG-2252), with how long
 * it has been failing (`first_failed_at`, else `at`). The raw code, the VMS's
 * own words and the failing-since/latest times are on hover. Renders nothing
 * while there is no error, or on an admin that doesn't send the field.
 */
export const LoginFailingLine = ({ error }: { error: unknown }) => {
  const normalized = normalizeConnectionError(error);
  if (!normalized) return null;
  const advice = connectionErrorAdvice(normalized);
  return (
    <div
      className="w-full font-mulish text-[12px] text-red-600 pt-[4px]"
      title={advice.detailLine}
      data-testid="login-failing-line"
    >
      Login failing: {advice.title}
      {advice.raw.firstFailedAt
        ? ` (failing for ${advice.raw.firstFailedRelative.replace(
            / ago$/,
            ""
          )})`
        : ""}
    </div>
  );
};
